import { Box, Button, Divider, Typography } from "@mui/material";
import React, { useState } from "react";
import { UiTextField } from "shared/ui/UiInputs/UiTextField";
import style from "../loadFile/loadFile.module.scss";
import { ICreateMarathon } from "features/createEditMarathon/model/types";
import {
  Control,
  FieldArrayWithId,
  UseFieldArrayAppend,
  UseFormRegister,
  useFormContext,
} from "react-hook-form";
import { buttonFileStyle } from "shared/lib/style";
import fileIcon from "assets/images/myDocument/file.svg";
import btnIcon from "assets/images/myDocument/btn_icon.svg";
import trashRedImg from "assets/images/admin/trash_red.svg";
import { usePartnerCompany } from "features/createEditMarathon/model/hooks/marathonTabsHooks/usePartnerCompany";
import { MarathonPartnerLogo } from "./MarathonPartnerLogo";
import { useTranslation } from "react-i18next";

interface PartnerProps {
  data: ICreateMarathon;
  remove: (index: number) => void;
  append: UseFieldArrayAppend<ICreateMarathon, "partners">;
  register: UseFormRegister<ICreateMarathon>;
  indexLanguage: number;
  partner: FieldArrayWithId<ICreateMarathon, "partners", "id">;
  index: number;
  control: Control<ICreateMarathon, any>;
}

export const Partner: React.FC<PartnerProps> = ({
  data,
  indexLanguage,
  partner,
  register,
  remove,
  index,
  control,
}) => {
  const [isDragOpen, setIsDragOpen] = useState(false);
  const { t } = useTranslation();

  const {
    append: appendPartnerCompany,
    fields,
    remove: removePartnerCompany,
  } = usePartnerCompany({
    control,
    index,
  });

  const {
    formState: { errors },
  } = useFormContext<ICreateMarathon>();
  const handleDowloadImage = (e: any) => {
    if (e?.target?.files)
      // @ts-ignore
      appendPartnerCompany({
        // @ts-ignore
        logo: e?.target?.files,
        name: "",
        url: "",
      });
  };
  const isImageError = errors.partners?.[index]?.translations?.[indexLanguage]?.name?.message;

  return (
    <Box key={partner.id}>
      <UiTextField
        inputProps={{
          ...register(`partners.${index}.translations.${indexLanguage}.name`),
        }}
        placeholder={t("createMarathon.headerPlaceholder")}
        label={t("createMarathon.header")}
        error={
          errors.partners?.[index]?.translations?.[indexLanguage]?.name?.message
        }
      />
      {!fields.length && (
        <Box>
          <label className={`label-personalCabinet ${style.label}`} htmlFor="-">
            {t("createMarathon.logos")}
            <div
              style={{
                border: !!isImageError ? "2px solid #d4322a" : "",
                backgroundColor: !!isImageError ? "rgba(255, 0, 0, 0.05)" : "",
              }}
              className={`${style.box_load} ${isDragOpen ? style.box_load_drag : ""
                }`}
              onDragStart={(e) => {
                e.preventDefault();
                setIsDragOpen(true);
              }}
              onDragLeave={(e) => {
                e.preventDefault();
                setIsDragOpen(false);
              }}
              onDragOver={(e) => {
                e.preventDefault();
                setIsDragOpen(true);
              }}
              onDrop={(e) => {
                e.preventDefault();
                const file = e.dataTransfer.files;
                // @ts-ignore
                appendPartnerCompany({
                  // @ts-ignore
                  logo: file,
                  name: "",
                  url: "",
                });
                setIsDragOpen(false);
              }}
            >
              <img src={fileIcon} alt="Файл" />
              <div className={style.box_load_text}>
                {isDragOpen ? (
                  <p>{t("createMarathon.dropToLoad")}</p>
                ) : (
                  <>
                    <p>
                      {t("createMarathon.fileDrag1")} <br /> {t("createMarathon.fileDrag2")}
                    </p>

                    <Button
                      variant="contained"
                      component="label"
                      sx={buttonFileStyle}
                      className={style.box_load_btn}
                    >
                      <img src={btnIcon} alt={t("createMarathon.chooseFile")} />
                      <span>{t("createMarathon.chooseFile")}</span>
                      <input
                        type="file"
                        onChange={handleDowloadImage}
                        accept="image/*"
                        hidden
                      />
                    </Button>
                  </>
                )}
              </div>
            </div>
          </label>
          <Box>
            <Box className="globalErrorMessage">{isImageError}</Box>
          </Box>
        </Box>
      )}
      {fields.length ? (
        <>
          <label className={style.label}>{t("createMarathon.logos")}</label>
          <Box className={style.box_img}>
            {fields.map((item2, index2) => (
              <MarathonPartnerLogo
                register={register}
                item={item2}
                removePartnerCompany={removePartnerCompany}
                appendPartnerCompany={appendPartnerCompany}
                index={index}
                index2={index2}
                key={index2}
              />
            ))}
          </Box>
        </>
      ) : null}
      {fields.length ? (
        <label className={style.text_add}>
          {t("createMarathon.addLogo")}
          <input
            type="file"
            accept="image/*"
            onChange={handleDowloadImage}
            multiple
            hidden
          />
        </label>
      ) : null}
      {data.partners.length > 1 ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            my: "16px",
            cursor: "pointer",
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            remove(index);
          }}
        >
          <Divider sx={{ background: "red", flex: 1 }} />
          <Typography className={style.deleteText}>{t("createMarathon.deletePartner")}</Typography>
          <img src={trashRedImg} alt="" />
          <Divider sx={{ background: "red", flex: 1 }} />
        </Box>
      ) : null}
    </Box>
  );
};
